import { render, staticRenderFns } from "./ConfigurableProduct.vue?vue&type=template&id=547d1bfa&scoped=true&"
import script from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
export * from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurableProduct.vue?vue&type=style&index=0&id=547d1bfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d1bfa",
  null
  
)

export default component.exports